import { useMemo } from 'react';
import { analyze } from '../analyze.js';
import Sidebar from './Sidebar.jsx';
import Inspector from './Inspector.jsx';
import WritePane from './WritePane.jsx';
import Corkboard from './Corkboard.jsx';
import Notes from './Notes.jsx';
import Goals from './Goals.jsx';

export default function Editor({ nav, go, space, doc, chromeOn, newDoc, onSpaceDeleted, prefs, setPrefs }) {
  const editing = nav.mode === 'edit' && !nav.ask;
  // Lives here rather than in the write pane because two things need it: the
  // rendered page, and the readouts in the sidebar beside it.
  const analysis = useMemo(() => (editing && doc ? analyze(doc.content) : null), [editing, doc?.content, doc?.id]);

  // On the page the sidebar is always there. On the corkboard, the notes and
  // the goals there is nothing for Write and Edit to say, so it comes out only
  // when there is a conversation to hold.
  const showSide = chromeOn && (nav.tool === 'write' || (nav.ask && space));

  return (
    <div className="workspace">
      {chromeOn && (
        <Sidebar
          nav={nav} go={go} space={space} newDoc={newDoc}
          width={prefs.sidebarWidth} onWidth={w => setPrefs({ sidebarWidth: w })}
        />
      )}
      <main className="sheet">
        {nav.tool === 'write' && <WritePane nav={nav} go={go} space={space} doc={doc} editing={editing} analysis={analysis} newDoc={newDoc} />}
        {nav.tool === 'board' && <Corkboard go={go} space={space} newDoc={newDoc} />}
        {nav.tool === 'notes' && <Notes space={space} />}
        {nav.tool === 'goals' && <Goals space={space} onDeleted={onSpaceDeleted} />}
      </main>
      {showSide && (
        <Inspector
          nav={nav} go={go} space={space} doc={doc} analysis={analysis}
          width={prefs.inspectorWidth} onWidth={w => setPrefs({ inspectorWidth: w })}
        />
      )}
    </div>
  );
}
